export const setPurchasingItem = ({ commit }, itemToPurchase) => {
  commit("setPurchasingItem", itemToPurchase);
};
